module.exports = "/assets/peacock.png";